import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/functions'
// import * as firebaseui from 'firebaseui'
// firebase init - add your own config here
const firebaseConfig = {
  apiKey: 'AIzaSyALlREOuqN-Qk38RL_cQKFl9Z7488MZ494',
  authDomain: 'rux-data.firebaseapp.com',
  databaseURL: 'https://rux-data.firebaseio.com',
  projectId: 'rux-data',
  storageBucket: 'rux-data.appspot.com',
  messagingSenderId: '309786463618',
  appId: '1:309786463618:web:d1a303f3e712f5a4a5539b',
  measurementId: 'G-S22SC8HYVQ'
}

firebase.initializeApp(firebaseConfig)
const db = firebase.database()

const auth = firebase.auth()
// const uiConfig = new firebaseui.auth.AuthUI(auth)
const storage = firebase.storage()
const functions = firebase.functions()

export {
  db,
  auth,
  // uiConfig,
  firebase,
  storage,
  functions
}
